import useBundleTranslation from 'i18n';
import { useAppBuilderContext } from 'app/app/editor/context';
import { Box, MenuItem } from '@mui/material';
import { IMenuItem } from 'app/app/editor/tabs/elements/layout/context-menu/index';
import styles from 'app/app/editor/tabs/elements/layout/context-menu/ContextMenu.styles';
import IconMi from 'components/common/icon/IconMi';
import { getNodeByUid, getNodeWithParentByUid } from 'app/app/editor/page/getNodeByUid';
import insertNodeIntoPage from 'app/app/editor/page/insertNodeIntoPage';
import { processPageContainersUid } from 'app/app/editor/page';

export default function MenuItemWrap({ openWithUid, handleClose }: IMenuItem) {
    const { t } = useBundleTranslation(['app/portal-page-builder']);
    const ctx = useAppBuilderContext();
    if (openWithUid == 'page') {
        return null;
    }
    return (
        <MenuItem
            onClick={() => {
                const node = getNodeWithParentByUid(ctx.page.layout, openWithUid);
                if (node) {
                    const copy = structuredClone(node.node);
                    let newPage = insertNodeIntoPage(
                        ctx.page,
                        { type: 'container', params: { uid: '__mark' } },
                        node.parentNode.params.uid,
                        openWithUid,
                    );
                    processPageContainersUid(newPage.layout, 'container');

                    const oldNode = getNodeWithParentByUid(newPage.layout, openWithUid);
                    if (oldNode) {
                        oldNode.parentNode.elements?.splice(oldNode.nodeIndex, 1);
                    }

                    const containerNode = getNodeByUid(newPage.layout, '__mark');
                    if (containerNode) {
                        containerNode.elements = [copy];
                        containerNode.params.uid = node.parentNode.params.uid + '-0__mark';
                    }

                    processPageContainersUid(newPage.layout, 'container');

                    ctx.setPage(newPage, false);
                    ctx.sendMessage({ name: 'reloadPage' });
                }
                handleClose();
            }}
        >
            <Box sx={styles.iconHolder}>
                <IconMi icon={'new-square'} />
            </Box>
            <Box>{t('node_context_menu.wrap')}</Box>
        </MenuItem>
    );
}
